import React, { Fragment, useEffect, useRef } from 'react'
import DynamicView from './DynamicView'
import lang from "ac-lang-cn"
import './TabsView.less'
import { isJDiwork } from "../util"
import { v4 as uuid } from "uuid"
import { isFunction } from 'lodash';
/**
 *
 */
export default function TabsView(props) {
  const { query, diworkCode } = props || {}
  const { terminalType } = query || {}
  const rootStores = useRef({})

  rootStores.current.activePage = props.tabs.activeKey
  // 删掉没用的rootStore
  const billNos = props.tabs.panes?.map(item => item.billNo)
  for (let key in rootStores.current) {
    if (key !== 'activePage' && billNos.indexOf(key) === -1) {
      delete rootStores.current[key]
    }
  }
  // 更新当前页面pagestore的result
  if (rootStores.current.activePage && rootStores.current[rootStores.current.activePage]) {
    const currentPane = props.tabs.panes.find(p => p.billNo == props.tabs.activeKey)
    rootStores.current[rootStores.current.activePage].pageStore.setResult({...currentPane.params})
  }
  const onRootStoreCreated = (...args)=> {
    isFunction(props.onRootStoreCreated) && props.onRootStoreCreated(...args)
    const rootStore = args[0]
    rootStores.current[props.tabs.activeKey] = rootStore
  }

  const fragmentId = 'ynf_fragment_' + uuid()

  useEffect(() => {
    // TODO: (高)需要重构代码 -->不应该吧页面管理放到这里
    // 用于和工作台进行页签操作通信，与 jDiwork.onData 配合使用
    // 组件渲染完成后，与工作台进行数据通信，监听页面的刷新、关闭、重新打开等场景。
    if (isJDiwork() && diworkCode) {
      window.jDiwork.updateService({ serviceCode: diworkCode }, { customEdit: true });

      window.jDiwork.onData(diworkCode, async (data) => {
        const rootStore = rootStores.current[rootStores.current.activePage]
        if (data.action === 'isCloseAction') {
          const cardStoreKey = Object.keys(rootStore).find(key => rootStore[key].storeType === 'CardStore')
          const mode = rootStore[cardStoreKey]?.uiState;
          if (mode === 'edit' || mode === 'add') {
            rootStore.utils.confirm({
              title: lang.templateByUuid('UID:P_CORE-YNF-FE_1889CD4005B0000D', '页面中有未保存的数据，点击确定后将关闭页面，是否继续？'), onOk: () => {
                window.jDiwork.closeWin()
              }
            })
          } else {
            window.jDiwork.closeWin()
          }
        } else if (data.action === 'isReOpen') {
          const cardStoreKey = Object.keys(rootStore).find(key => rootStore[key].storeType === 'CardStore')
          const mode = rootStore[cardStoreKey]?.uiState;
          if (mode === 'edit' || mode === 'add') {
            rootStore.utils.confirm({
              title: lang.templateByUuid('UID:P_CORE-YNF-FE_1889CD4005B0000E', '页面中有未保存的数据，点击确定后将清除数据并重启页面，确定继续？'), onOk: async () => {
                window.jDiwork.updateService({ serviceCode: diworkCode }, { data: data.data.type.data, title: data.data.type.title, tnsKey: Date.now(), customEdit: true });
              }
            })
          } else {
            // 刷新
            window.jDiwork.updateService({ serviceCode: diworkCode }, { data: data.data.type?.data, title: data.data.type?.title, tnsKey: Date.now(), customEdit: true });
          }
        }
      });
    }
  }, [diworkCode])

  const getTab = () => {
    const activeKey = props.tabs.activeKey
    window.mtl?.onInterceptBack({
      callback: function() {
        if (window.onInterceptBack) {
          window.onInterceptBack()
        } else {
          props.history.goBack()
        }
	    }
    })
    return <div>
      {props.tabs.panes?.map(pane => <div className='fragment-tabs-view' key={pane?.billNo} style={{ visibility: pane.billNo === activeKey ? "visible" : "hidden" }} activeKey={props.tabs.activeKey}>
        {getView({ ...props, ...pane })}
      </div>)}
    </div>
  }
  const getPcTab = () => {
    const { Tabs, ConfigProvider } = TinperNext
    ConfigProvider.config({ locale: lang.getLanguage() })
    const { TabPane } = Tabs
    return <ConfigProvider locale={lang.getLanguage()}>
      <Tabs id={fragmentId} className='fragment-tabs-view' activeKey={props.tabs.activeKey} onChange={props.onTabChange}>
        {props.tabs.panes?.map(pane => <TabPane tab={pane.billNo} key={pane.billNo}>{getView({ ...props, ...pane })}</TabPane>)}
      </Tabs>
    </ConfigProvider>
  }

  const getView = (props) => {
    props.params.fragmentId = fragmentId
    return <DynamicView onRootStoreCreated={onRootStoreCreated} {...props}></DynamicView>
  }

  return (
    <Fragment>
      {terminalType == 3 ? getTab() : getPcTab()}
    </Fragment>
  )
}
